import React, { lazy } from 'react';
import { useLanguage } from '../contexts/LanguageContext';
export function LogoCarousel() {
  const {
    language
  } = useLanguage();
  const logos = [{
    url: 'https://cdn.magicpatterns.com/uploads/newgErtKDKrLYFC84cGBeb/abc_natur_.png',
    alt: 'ABC Natur'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/urQottB4WA5JLSCCJGmaF3/mambo.png',
    alt: 'Mambo Software'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/wuFAdo9BXQzwYEkgjDZShQ/heylloyd-image-1776515593875.png',
    alt: 'Punku'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/13jSfHmWRtzVAm2rkwtSSo/heylloyd-image-1776515658818.png',
    alt: 'Mila Haru Editorial'
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/5pBhVPR2WraZhzx8rYpt8T/WhatsApp_Image_2026-04-18_at_2.38.26_p._m..jpg',
    alt: 'Tomille Consulting'
  }];
  return <section className="py-8 md:py-12 bg-brand-darker border-y border-white/5 overflow-hidden" data-id="element-207">
      <div className="container mx-auto px-4 md:px-6 mb-6 md:mb-8 text-center" data-id="element-208">
        <p className="text-xs md:text-sm font-semibold text-gray-400 tracking-widest uppercase" data-id="element-209">
          {language === 'es' ? 'Empresas que ya confían en Kinetic Growth Studio' : 'Companies that already trust Kinetic Growth Studio'}
        </p>
      </div>

      {/* Infinite Scroll Container */}
      <div className="relative w-full flex overflow-hidden group" data-id="element-210">
        {/* Gradient Masks for smooth fade on edges - smaller on mobile */}
        <div className="absolute top-0 left-0 w-16 md:w-32 h-full bg-gradient-to-r from-brand-darker to-transparent z-10" data-id="element-211"></div>
        <div className="absolute top-0 right-0 w-16 md:w-32 h-full bg-gradient-to-l from-brand-darker to-transparent z-10" data-id="element-212"></div>

        <div className="flex animate-infinite-scroll" data-id="element-213">
          {/* First set of logos */}
          {logos.map((logo, index) => <div key={`logo-1-${index}`} className="flex items-center justify-center px-6 md:px-12 shrink-0" data-id="element-214">
              <img src={logo.url} alt={logo.alt} loading="lazy" className="h-10 md:h-16 w-auto object-contain grayscale opacity-40 hover:opacity-60 transition-opacity duration-300" data-id="element-215" />
            </div>)}
          {/* Duplicated set for seamless loop */}
          {logos.map((logo, index) => <div key={`logo-2-${index}`} className="flex items-center justify-center px-6 md:px-12 shrink-0" data-id="element-216">
              <img src={logo.url} alt={logo.alt} loading="lazy" className="h-10 md:h-16 w-auto object-contain grayscale opacity-40 hover:opacity-60 transition-opacity duration-300" data-id="element-217" />
            </div>)}
        </div>
      </div>
    </section>;
}